import { CFCell } from "./CustomField/CFCell";
import { ExtraInfo } from "./ExtraInfo/ExtraInfo";
import { InvoicesColumn } from "./Invoices/InvoicesColumn";
import { TextCCell } from "./Text/TextCCell";
import { TextPopoverCell } from "./Text/TextPopoverCell";

export const cellComponents = {
  invoices: InvoicesColumn,
  textPopOver: TextPopoverCell,
  textColumn: TextCCell,
  cfCell: CFCell,
  extraInfo: ExtraInfo,
};
